export default "__VITE_ASSET__ebe18bcb__"